export default __webpack_public_path__ + "static/media/barra1.65d84710.png";